import React, { Component } from 'react';
import { Popover, Spin } from 'antd';
import { dealValueShow, judgeObj } from '@/shared/functions';
import Api from '@/services';
class Purchase extends Component {
    constructor(props) {
        super(props);
        /**
        * @desc 采购信息Dom
        */
        this.purchaseInfoDom = () => {
            const { purchaseInfo, purchaseLoading } = this.state;
            const { isDeductionModels, isMaleHouseholdPayment, procurementType } = purchaseInfo || {};
            return (<Spin spinning={purchaseLoading}>
        <div>
            <p>采购类型：{dealValueShow(procurementType)}</p>
            <p>是否抵扣车款：{dealValueShow(isDeductionModels)}</p>
            <p>是否公户付款：{dealValueShow(isMaleHouseholdPayment)}</p>
        </div>
      </Spin>);
        };
        this.handleHoverChange = (visible) => {
            this.setState({
                hovered: visible,
                clicked: false,
            });
        };
        this.handleClickChange = (visible) => {
            this.setState({
                clicked: visible,
                hovered: false,
            });
        };
        this.seePurchaseInfo = () => {
            const { canRequest } = this.state;
            const { orderId } = this.props;
            if (canRequest) {
                this.setState({ canRequest: false, purchaseLoading: true, purchaseInfo: {} });
                Api.order.getProcurementInfo({ orderId }).then((_r) => {
                    if (_r && judgeObj(_r)) {
                        this.setState({
                            purchaseInfo: _r,
                        });
                    }
                }).finally(() => {
                    this.setState({
                        purchaseLoading: false,
                    });
                });
            }
        };
        this.onMouseLeave = () => {
            this.setState({ canRequest: true });
        };
        this.state = {
            purchaseInfo: {},
            purchaseLoading: false,
            canRequest: true,
            hovered: false,
            clicked: false,
        };
    }
    render() {
        const { hovered, clicked } = this.state;
        return (<Popover placement="bottom" content={this.purchaseInfoDom()} trigger="hover" visible={hovered} onVisibleChange={this.handleHoverChange} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
        <Popover placement="bottom" content={this.purchaseInfoDom()} trigger="click" visible={clicked} onVisibleChange={this.handleClickChange} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
          <a href="javascript:;" onClick={this.seePurchaseInfo} onMouseEnter={this.seePurchaseInfo} onMouseLeave={this.onMouseLeave}>
            查看
          </a>
        </Popover>
      </Popover>);
    }
}
export default Purchase;
